import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\UserPasswordController::update
* @see app/Http/Controllers/Api/UserPasswordController.php:16
* @route '/api/users/passwords'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

update.definition = {
    methods: ["post"],
    url: '/api/users/passwords',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\UserPasswordController::update
* @see app/Http/Controllers/Api/UserPasswordController.php:16
* @route '/api/users/passwords'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\UserPasswordController::update
* @see app/Http/Controllers/Api/UserPasswordController.php:16
* @route '/api/users/passwords'
*/
update.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

const passwords = {
    update: Object.assign(update, update),
}

export default passwords